// utils/permissions.ts
export function hasGroup(me: any, key: string) {
  if (!me) return false;
  if (me.userGroups.includes("Administrator")) return true;
  return me?.userGroups?.includes(key) ?? false;
}
